import validate from "/app/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_io_45f5835dc264c2769e464e2e6205b9bf/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_io_45f5835dc264c2769e464e2e6205b9bf/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "referrer-guard": () => import("/app/src/middleware/referrerGuard.ts")
}